import React, { Component } from "react";
import { Table, Modal} from "react-bootstrap";
var dateFormat = require("dateformat");

class ViewDeliveryStatus extends Component {
  render() {
    const { showDetailModal, closeDetailModal, statuses } =this.props;
  
    const data = statuses?statuses:null;

    return (
      <div>
        <div>
          <Modal
            show={showDetailModal}
            onHide={closeDetailModal}
            animation={false}
            size="lg"
            backdrop="static"
            centered={true}
          >
            <Modal.Header
              style={{ fontSize: "35px", backgroundColor: "#f0f3f5" }}
              closeButton
            >
              <Modal.Title>
                <span style={{ fontSize: "20px" }}>Delivery Status Details</span>
              </Modal.Title>
            </Modal.Header>

            <Modal.Body>
              <div>
                <div className="feedbkModalTbl">
                  <Table responsive bordered className="cmnMainTable">
                    <tbody>
                    <tr>
                        <td className="feedbkTdWdth">Delivery Status</td>
                        <td className="storeModalCap">
                              {data !== null && data.name}
                            </td>
                      </tr>

                      <tr>
                        <td className="feedbkTdWdth">Status Description</td>
                        <td className="storeModalCap">
                              {data !== null && data.disc}
                            </td>
                      </tr>
                      <tr>
                        <td className="feedbkTdWdth">Sort Order</td>
                        <td className="storeModalCap">
                              {data !== null && data.sortOrder}
                            </td>
                      </tr>
                      <tr>
                        <td className="feedbkTdWdth">Status</td>
                        <td className="storeModalCap">
                              {data !== null && data.isActive ? "Active" : "Suspended"}
                            </td>
                      </tr>
                      <tr>
                        <td className="feedbkTdWdth"> Created Date</td>
                        <td className="storeModalCap">
                              {data !== null && dateFormat(data.createdAt, "mediumDate")}
                            </td>
                      </tr>
                      <tr>
                        <td className="feedbkTdWdth"> Updated Date</td>
                        <td className="storeModalCap">
                              {data !== null && dateFormat(data.updatedAt, "mediumDate")}
                            </td>
                      </tr>
                    </tbody>
                  </Table>
                </div>
              </div>
            </Modal.Body>
            <Modal.Footer style={{ backgroundColor: "#f0f3f5" }}></Modal.Footer>
          </Modal>
        </div>
      </div>
    );
  }
}

export default ViewDeliveryStatus;
